import JourneyLeg from '@models/JourneyLeg'
import { getAllActiveJourneys } from '@state/queries/journeys/get-all-active-journeys'

export const getLegsWithReservations = () => {
  const journeysIds = getAllActiveJourneys()
    .flatMap((journey) => journey.legs)
    .filter((leg) => leg.reservations.length > 0)
    .flatMap((leg) => leg.id)

  return JourneyLeg.query()
    .withAllRecursive()
    .whereIdIn(journeysIds)
    .get()
}
